var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col } from "react-bootstrap";
import classNames from "classnames";
import ValidationInput from "@irati/utils/validation/Input";
import ErrorText from "../ErrorText";
var FormItemFormError = /** @class */ (function (_super) {
    __extends(FormItemFormError, _super);
    function FormItemFormError(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errorMsg: null,
            value: props.value
        };
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    FormItemFormError.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    FormItemFormError.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    FormItemFormError.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ value: nextProps.value });
    };
    FormItemFormError.prototype.render = function () {
        var errorMsg = this.state.errorMsg;
        var className = classNames("perkboxFormError", this.props.className);
        return (React.createElement(Col, { xs: 12, className: className }, errorMsg && (React.createElement(ErrorText, { small: true }, errorMsg))));
    };
    FormItemFormError.defaultProps = {
        className: ""
    };
    return FormItemFormError;
}(Component));
export { FormItemFormError };
export default FormItemFormError;
